import { Injectable } from '@angular/core';
import OrdenesTrabajoTable from './ordenesTrabajo/ordenesTrabajoTable';
import ValoresTable from './valores/valoresTable';
import DatabaseTable from '../model/database/generic/databaseTable';
import { IDBPDatabase, IDBPTransaction } from 'idb';
import ProgramacionesTable from './programaciones/programacionesTable';
import FotosTable from './fotos/fotosTable';
import ValoracionesTable from './valoraciones/valoracionesTable';
import AdjuntosTable from './adjuntos/adjuntosTable';
import FirmasConformidadTable from './firmasConformidad/firmasConformidadTable';
import FirmasConservadorTable from './firmasConservador/firmasConservadorTable';
import ImagenesParametrosTable from './imagenesParametros/imagenesParametrosTable';
import FirmasInspectorTable from './firmasInspector/firmasInspectorTable';
import DirectoriesTable from './directories/directoriesTable';
import MateriasPeligrosasAdrTable from './materiasPeligrosasAdr/materiasPeligrosasAdrTable';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  //#region Constructor

  constructor() {

    // Ñapilla para exponer la base de datos al Window para poder depurar, solo en versión local
    if (location.hostname == 'localhost' && window["database"] == null) {
      window["database"] = this
    }

  }

  //#endregion

  //#region Tablas

  public Tables: DatabaseTable<any>[] = []

  public OrdenesTrabajo = new OrdenesTrabajoTable(this, {
    primaryKeyField: "LocalId",
    autoIncrement: true,
    tableName: "OrdenesTrabajo",
    indexes: [{
      Name: 'Id',
      Field: 'Id',
      Unique: true
    }]
  })

  public Valores = new ValoresTable(this, {
    primaryKeyField: "Id",
    autoIncrement: false,
    tableName: "Valores",
    indexes: [{
      Name: "ParametroId",
      Field: "ParametroId",
      Unique: false
    }]
  })

  public ImagenesParametros = new ImagenesParametrosTable(this, {
    primaryKeyField: 'LocalId',
    autoIncrement: true,
    tableName: "ImagenesParametros",
    indexes: [{
      Name: "Codigo",
      Field: "Codigo",
      Unique: false
    }]
  })

  public Programaciones = new ProgramacionesTable(this, {
    primaryKeyField: "Id",
    autoIncrement: true,
    tableName: "Programaciones",
    indexes: [{
      Name: "AreaId",
      Field: "AreaId",
      Unique: true
    }]
  })

  public Fotos = new FotosTable(this, {
    primaryKeyField: "LocalId",
    autoIncrement: true,
    tableName: "Fotos",
    indexes: [{
      Name: 'Id',
      Field: 'Id',
      Unique: false
    }, {
      Name: 'OrdenLocalId',
      Field: 'OrdenLocalId',
      Unique: false
    }]
  })

  public Adjuntos = new AdjuntosTable(this, {
    primaryKeyField: "LocalId",
    autoIncrement: true,
    tableName: "Adjuntos",
    indexes: [{
      Name: 'Id',
      Field: 'Id',
      Unique: false
    }, {
      Name: 'OrdenLocalId',
      Field: 'OrdenLocalId',
      Unique: false
    }]
  })

  public FirmasConformidad = new FirmasConformidadTable(this, {
    primaryKeyField: "LocalId",
    autoIncrement: true,
    tableName: "FirmasConformidad",
    indexes: [{
      Name: "Id",
      Field: "Id",
      Unique: false
    }, {
      Name: "OrdenLocalId",
      Field: "OrdenLocalId",
      Unique: false
    }]
  })

  public FirmasConservador = new FirmasConservadorTable(this, {
    primaryKeyField: "LocalId",
    autoIncrement: true,
    tableName: "FirmasConservador",
    indexes: [{
      Name: "Id",
      Field: "Id",
      Unique: false
    }, {
      Name: "OrdenLocalId",
      Field: "OrdenLocalId",
      Unique: false
    }]
  })

  public FirmasInspector = new FirmasInspectorTable(this, {
    primaryKeyField: "LocalId",
    autoIncrement: true,
    tableName: "FirmasInspector",
    indexes: [{
      Name: "Id",
      Field: "Id",
      Unique: false
    }, {
      Name: "OrdenLocalId",
      Field: "OrdenLocalId",
      Unique: false
    }]
  })

  public Valoraciones = new ValoracionesTable(this, {
    primaryKeyField: "Id",
    autoIncrement: false,
    tableName: "Valoraciones",
    indexes: [{
      Name: 'Id',
      Field: 'Id',
      Unique: true
    }]
  })

  public Directories = new DirectoriesTable(this, {
    primaryKeyField: "Id",
    autoIncrement: true,
    tableName: "Directories",
    indexes: [{
      Name: 'Purpose',
      Field: 'Purpose',
      Unique: true
    }]
  })

  public MateriasPeligrosasAdr = new MateriasPeligrosasAdrTable(this, {
    primaryKeyField: "IdMateria",
    autoIncrement: false,
    tableName: "MateriasPeligrosasAdr",
    indexes: [{
      Name: "IdMateria",
      Field: "IdMateria",
      Unique: true
    }, {
      Name: "EsVehiculoAT",
      Field: "EsVehiculoAT",
      Unique: false
    }, {
      Name: "EsVehiculoFL",
      Field: "EsVehiculoFL",
      Unique: false
    }, {
      Name: "EsVehiculoExIII",
      Field: "EsVehiculoExIII",
      Unique: false
    }, {
      Name: "SoportaLiquido",
      Field: "SoportaLiquido",
      Unique: false
    }, {
      Name: "SoportaSolido",
      Field: "SoportaSolido",
      Unique: false
    }]
  })

  //#endregion
  
  //#region Base de datos

  public Name: string = 'Ingein'
  public Version: number = 19

  //#endregion

  //#region Actualización de stores

  public async UpgradeDatabases(db: IDBPDatabase, transaction: IDBPTransaction<unknown, string, 'versionchange'>): Promise<void> {
    for (let table of this.Tables) {
      await table.UpgradeTable(db, transaction)
    }
  }

  //#endregion

}
